"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidLCE = exports.isValidErrorLCE = exports.isValidContentLCE = exports.isValidFetchingLCE = exports.isValidNotRequestedLCE = exports.hasPreviousContent = exports.isError = exports.isExpiredContent = exports.isUnexpiredContent = exports.isContent = exports.isFetching = exports.isNotRequested = exports.isValidContent = void 0;
const isExpired_1 = require("./isExpired");
const models_1 = require("./models");
/**
 * Returns whether or not @param x is an instance of @type VALID_CONTENT.
 */
const isValidContent = (x) => {
    switch (typeof x) {
        case "object":
        case "boolean":
        case "number":
        case "string":
            return true;
        default:
            return false;
    }
};
exports.isValidContent = isValidContent;
/**
 * Returns whether or not @param x is an instance of @type NOT_REQUESTED. This is a basic type check.
 * For full validation that a type conforms to the LCE schema, use @function isValidNotRequestedLCE.
 */
const isNotRequested = (x) => (x === null || x === void 0 ? void 0 : x.type) === models_1.LCEType.NotRequested;
exports.isNotRequested = isNotRequested;
/**
 * Returns whether or not @param x is an instance of @type IS_FETCHING. This is a basic type check.
 * For full validation that a type conforms to the LCE schema, use @function isValidFetchingLCE.
 */
const isFetching = (x) => (x === null || x === void 0 ? void 0 : x.type) === models_1.LCEType.Fetching;
exports.isFetching = isFetching;
/**
 * Returns whether or not @param x is an instance of @type CONTENT. This is a basic type check.
 * For full validation that a type conforms to the LCE schema, use @function isValidContentLCE.
 */
const isContent = (x) => (x === null || x === void 0 ? void 0 : x.type) === models_1.LCEType.Content;
exports.isContent = isContent;
/**
 * Returns whether or not @param x is an instance of @type CONTENT and is unexpired.
 * Throws if @param x doesn't have a cache time set.
 */
const isUnexpiredContent = (x) => exports.isContent(x) && isExpired_1.isUnexpired(x);
exports.isUnexpiredContent = isUnexpiredContent;
/**
 * Returns whether or not @param x is an instance of @type CONTENT and is expired.
 * Throws if @param x doesn't have a cache time set.
 */
const isExpiredContent = (x) => exports.isContent(x) && isExpired_1.isExpired(x);
exports.isExpiredContent = isExpiredContent;
/**
 * Returns whether or not @param x is an instance of @type ERROR. This is a basic type check.
 * For full validation that a type conforms to the LCE schema, use @function isValidErrorLCE.
 */
const isError = (x) => (x === null || x === void 0 ? void 0 : x.type) === models_1.LCEType.Error;
exports.isError = isError;
/**
 * Returns whether or not @param x has a defined `previousContent` property
 */
const hasPreviousContent = (x) => !!x && "previousContent" in x && x.previousContent !== undefined;
exports.hasPreviousContent = hasPreviousContent;
const isValidLCECore = (x, expectedType) => typeof x === "object" && x != null && x.type === expectedType;
/**
 * Returns whether or not @param x is an instance of @type NOT_REQUESTED.
 */
const isValidNotRequestedLCE = (x) => isValidLCECore(x, models_1.LCEType.NotRequested);
exports.isValidNotRequestedLCE = isValidNotRequestedLCE;
/**
 * Returns whether or not @param x is an instance of @type IS_FETCHING.
 */
const isValidFetchingLCE = (x) => isValidLCECore(x, models_1.LCEType.Fetching) && isValidPreviousContent(x);
exports.isValidFetchingLCE = isValidFetchingLCE;
/**
 * Returns whether or not @param x is an instance of @type CONTENT.
 */
const isValidContentLCE = (x) => isValidLCECore(x, models_1.LCEType.Content) &&
    exports.isValidContent(x.data) &&
    typeof x.lastFetchedMS === "number" &&
    x.lastFetchedMS > 0 &&
    (x.cacheTimeInMS == null || typeof x.cacheTimeInMS === "number");
exports.isValidContentLCE = isValidContentLCE;
const isValidPreviousContent = (x) => 
// Return true if previousContent key is not present or is undefined
!("previousContent" in x) || x.previousContent === undefined || exports.isValidContentLCE(x.previousContent);
/**
 * Returns whether or not @param x is an instance of @type ERROR.
 */
const isValidErrorLCE = (x) => isValidLCECore(x, models_1.LCEType.Error) &&
    typeof x.error === "object" &&
    x.error != null &&
    typeof x.occurredOnMS === "number" &&
    x.occurredOnMS > 0 &&
    isValidPreviousContent(x);
exports.isValidErrorLCE = isValidErrorLCE;
/**
 * Returns whether or not @param x is an instance of @type LCE, i.e. an instance of
 * @type NOT_REQUESTED or @type IS_FETCHING or @type CONTENT or @type ERROR.
 */
const isValidLCE = (x) => exports.isValidNotRequestedLCE(x) || exports.isValidFetchingLCE(x) || exports.isValidContentLCE(x) || exports.isValidErrorLCE(x);
exports.isValidLCE = isValidLCE;
//# sourceMappingURL=typeGuards.js.map